export default /<\/{0,1}[^>]+>/g;
